/**
 * Venue ids from a group that this report is allowed to use.
 * A group venue that is not on the report list is counted as left out.
 */
export const venueIdsForReportGroup = (group, allowedVenues) => {
  const allowed = new Map(
    (allowedVenues || [])
      .map(venue => [String(venue?._id || venue), venue?._id || venue])
      .filter(([id]) => id),
  )
  const groupIds = (group?.venues || [])
    .map(venue => String(venue?._id || venue))
    .filter(Boolean)
  const venueIds = groupIds
    .filter(id => allowed.has(id))
    .map(id => allowed.get(id))
  return {
    venueIds,
    leftOut: groupIds.length - venueIds.length,
  }
}

export const reportGroupOptionLabel = group => {
  const count = (group?.venues || []).length
  const name = group?.name || 'Group'
  const noun = count === 1 ? 'venue' : 'venues'
  return `${name} (${count} ${noun})`
}

export const reportGroupLeftOutSentence = ({ leftOut }) => {
  const missing = Number(leftOut) || 0
  if (missing <= 0) return ''
  const leftNoun = missing === 1 ? 'venue' : 'venues'
  const verb = missing === 1 ? 'is' : 'are'
  return `${missing} ${leftNoun} in this group ${verb} not on this list.`
}

export const reportGroupInReportSentence = ({ venueIds }) => {
  const count = (venueIds || []).length
  const noun = count === 1 ? 'venue' : 'venues'
  return `${count} ${noun} will be in this report.`
}

export const reportGroupPickNote = picked => {
  const countLine = reportGroupInReportSentence(picked)
  const leftOut = reportGroupLeftOutSentence(picked)
  return leftOut ? `${countLine} ${leftOut}` : countLine
}
